

export const euroTenant = {
  name: 'euro',
  properties: {
    // Primary colors
    '--primary': '#004298',
    '--secondary': '#004298',
    '--tertiary': '#e3e829',
    '--quarter': '#54555a',
    '--error': 'red',
    '--nav-bar': '#fff',

    /* Buttons */
    // Primary
    '--color-button-primary': '#fff',
    '--bg-color-button-primary': '#ffe900',
    '--hover-color-button-primary': '#fff',
    '--hover-bg-color-button-primary': '#004298',
    // Secondary
    '--color-button-secondary': '#fff',
    '--bg-color-button-secondary': '#ffe900',
    '--hover-color-button-secondary': '#fff',
    '--bg-hover-color-button-secondary': '#004298',
    // Tertiary
    '--color-button-tertiary': '#fff',
    '--bg-color-button-tertiary': '#ffe900',
    '--hover-color-button-tertiary': '#fff',
    '--bg-hover-color-button-tertiary': '#004298',

    // Forms
    '--color-input-valid': '#004298',

    // Fonts
    '--primary-semibold-font-family': 'FSJoeySemiBold',
    '--font-family-secondary': `'Barlow', sans-serif`,
    '--font-family-secondary-medium': `'Barlow', sans-serif`,

    // Header
    '--background-header': '#fff',
    '--color-breadcrumb': '#00595f',
    '--color-breadcrumb-sucess': '#ffeb00',
    '--logo': 'url(../../../../assets/images/tenants/euro/logo.png)',

    // Footer
    '--footer-color': '#fff',

    // EURO
    '--color-tittle-h2': 'var(--primary)',
    '--color-tittle-h3': 'var(--secondary)',
  }
};
